import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { useApp } from '../../context/AppContext';

const FAQPage = () => {
  const [openIndex, setOpenIndex] = React.useState(null);
  const { t } = useApp();

  const faqs = [
    {
      question: t('faq_delivery_time_q'),
      answer: t('faq_delivery_time_a')
    },
    {
      question: t('faq_original_q'),
      answer: t('faq_original_a')
    },
    {
      question: t('faq_return_q'),
      answer: t('faq_return_a')
    },
    {
      question: t('faq_payment_methods_q'),
      answer: t('faq_payment_methods_a')
    },
    {
      question: t('faq_track_order_q'),
      answer: t('faq_track_order_a')
    },
    {
      question: t('faq_gift_wrap_q'),
      answer: t('faq_gift_wrap_a')
    },
    {
      question: t('faq_direct_delivery_q'),
      answer: t('faq_direct_delivery_a')
    },
    {
      question: t('faq_2fa_q'),
      answer: t('faq_2fa_a')
    }
  ];

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col">
      <Navbar />
      
      <main className="flex-1 container mx-auto px-4 md:px-8 py-12">
        <h1 className="font-heading text-3xl md:text-4xl text-white mb-2">{t('faq_title')}</h1>
        <p className="text-[#A8A29E] mb-8">{t('faq_subtitle')}</p>

        <div className="max-w-3xl space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="glass rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="text-white font-medium pr-4">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp size={20} className="text-[#D4AF37] flex-shrink-0" />
                ) : (
                  <ChevronDown size={20} className="text-[#A8A29E] flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 pt-0">
                  <p className="text-[#A8A29E] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default FAQPage;
